import React from 'react';
import FormInput from '~/components/form-input/form-input';
import FormSelect from '~/components/form-select/form-select';
import FormRadioGroup from '~/components/form-radiogroup/form-radiogroup';
import useMatchingSchools, { schoolTypeValues } from '~/models/use-school-suggestion-list';
import { useIntl, FormattedMessage } from 'react-intl';
import './school-selector.scss';
export default function SchoolSelector({ initialValue = '' }) {
    const [value, setValue] = React.useState(initialValue);
    const { schoolNames, schoolIsOk, selectedSchool } = useMatchingSchools(value);
    const showSchoolInfo = !schoolIsOk && value.length > 3;
    const onChange = React.useCallback(({ target }) => setValue(target.value), []);
    const { formatMessage } = useIntl();
    React.useLayoutEffect(() => {
        if (showSchoolInfo) {
            if (document.hasFocus()) {
                const putFocusBack = document.activeElement;
                window.setTimeout(() => {
                    putFocusBack.focus();
                }, 40);
            }
        }
    }, [showSchoolInfo]);
    return (React.createElement("div", null,
        React.createElement(FormInput, { label: formatMessage({ id: 'contact-info.school' }), suggestions: schoolNames, inputProps: {
                type: 'text',
                name: 'school',
                required: true,
                autoComplete: 'off',
                value,
                onChange
            } }),
        selectedSchool && React.createElement(SchoolHiddenInfo, { school: selectedSchool }),
        showSchoolInfo && React.createElement(SchoolInfo, null)));
}
function SchoolInfo() {
    const { formatMessage } = useIntl();
    // Because they have to be statically evaluate-able
    const schoolTypeLabels = {
        'College/University (4)': formatMessage({ id: 'school-type.College/University (4)' }),
        'Technical/Community College (2)': formatMessage({ id: 'school-type.Technical/Community College (2)' }),
        'Career School/For-Profit (2)': formatMessage({ id: 'school-type.Career School/For-Profit (2)' }),
        'High School': formatMessage({ id: 'school-type.High School' }),
        'K-12 School': formatMessage({ id: 'school-type.K-12 School' }),
        'Home School': formatMessage({ id: 'school-type.Home School' }),
        'Other': formatMessage({ id: 'school-type.Other' })
    };
    const schoolTypeOptions = schoolTypeValues.map((value) => ({
        label: schoolTypeLabels[value],
        value
    }));
    const schoolTypeLabel = formatMessage({ id: 'contact-info.school-type-label' });
    const schoolLocationLabel = formatMessage({ id: 'contact-info.school-location-label' });
    return (React.createElement("div", { className: "school-info" },
        React.createElement("div", { className: "instructions" },
            React.createElement(FormattedMessage, { id: "contact-info.school-not-found" })),
        React.createElement(FormSelect, { label: schoolTypeLabel, name: "school_type", selectAttributes: { required: true }, options: schoolTypeOptions }),
        React.createElement(FormRadioGroup, { longLabel: schoolLocationLabel, name: "school_location", options: [
                { label: formatMessage({ id: 'yes' }), value: 'Domestic' },
                { label: formatMessage({ id: 'no' }), value: 'Foreign' }
            ], required: true })));
}
function SchoolHiddenInfo({ school }) {
    var _a;
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { type: "hidden", name: "school_type", value: school.type }),
        React.createElement("input", { type: "hidden", name: "school_location", value: school.location }),
        React.createElement("input", { type: "hidden", name: "school_total_enrollment", value: (_a = school.total_school_enrollment) !== null && _a !== void 0 ? _a : '' })));
}
